import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddServiceTimingsComponent } from "src/app/shared/components/add-service-timings/add-service-timings.component";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { MeetingDataComponent } from "../new-v2-component/meeting-data/meeting-data.component";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { FormControl } from "@angular/forms";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { AddCustomerComponent } from "src/app/shared/components/add-customer/add-customer.component";
import { CreateInvoiceForCustomersComponent } from "src/app/shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { CustomersViewDetailsComponent } from "../new-v2-component/customers-view-details/customers-view-details.component";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { formatDate } from "@angular/common";
import { CreateInvoiceForFitnessComponent } from "src/app/shared/components/create-invoice-for-fitness/create-invoice-for-fitness.component";
import { MarkAbsentComponent } from "../new-v2-component/mark-absent/mark-absent.component";
import { PhoneCheckForMemberComponent } from "../new-v2-component/phone-check-for-member/phone-check-for-member.component";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-all-members",
  templateUrl: "./all-members.component.html",
  styleUrls: ["./all-members.component.scss"],
})
export class AllMembersComponent implements OnInit, OnDestroy {
  isEntityIndividual: any;
  hidediv: boolean = false;
  searchString: FormControl = new FormControl("");
  loader: boolean = false;
  apisub: Subscription;
  businessListData: any[] = [];
  serviceTimings: any[] = [];
  finalServiceTimings: any[] = [];
  selectedBusiness: any;
  selectedServiceType: any = "1";
  groupedServiceTimings: any = null;
  page: number = 1;
  datalength!: number;
  toShowTimings: boolean = false;
  membersData: any[] = [];
  daysOfWeek = [
    { day: 1, name: "Sunday" },
    { day: 2, name: "Monday" },
    { day: 3, name: "Tuesday" },
    { day: 4, name: "Wednesday" },
    { day: 5, name: "Thursday" },
    { day: 6, name: "Friday" },
    { day: 7, name: "Saturday" },
  ];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name",
    },
    {
      columnName: "phone",
      columnProperty: "member_phone",
    },
    {
      columnName: "gender",
      columnProperty: "gender",
    },
    {
      columnName: "last payment date",
      columnProperty: "last_payment_dt",
    },
    {
      columnName: "Service mode",
      columnProperty: "s_mode",
    },
    {
      columnName: "total due",
      columnProperty: "total_due",
    },
  ];
  isEmployeeAndHasBusinessButDoesNotHaveAccess: boolean = false;
  constructor(
    private apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private navservice: NavigationService,
    private router: Router,
    private _modelRef: MatDialog,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST
      ) {
        this.businessListData = [];
        if (resdata.result) {
          this.businessListData = resdata.result;
          this.businessListData.forEach((element: any) => {
            // Parse if string
            element.employee_functionality_list =
              typeof element.employee_functionality_list === "string"
                ? JSON.parse(element.employee_functionality_list)
                : element.employee_functionality_list;

            const list = element.employee_functionality_list || [];

            // Set defaults
            element.member_access = 0;
            element.customer_access = 0;
            element.service_access = 0;
            element.bookings_access = 0;

            if (Array.isArray(list)) {
              list.forEach((fn: any) => {
                const access = fn?.access_status === 1 ? 1 : 0;
                const name = fn?.functionality_name || "";

                switch (name) {
                  case "Member management":
                    element.member_access = access;
                    break;

                  case "Customer management":
                    element.customer_access = access;
                    break;

                  case "Services & Packages":
                    element.service_access = access;
                    break;

                  case "Booking history":
                    element.bookings_access = access;
                    break;

                  case "Shop/In-Premise operation":
                    element.shop_bookings_access = access;
                    break;

                  case "Home service operation":
                    element.home_bookings_access = access;
                    break;

                  case "Virtual service operation":
                    element.virtual_bookings_access = access;
                    break;

                  case "Invoice history":
                    element.invoice_history_access = access;
                    break;

                  case "Shop/In-Premise Invoicing":
                    element.shop_invoice_access = access;
                    break;

                  case "Home service invoicing":
                    element.home_invoice_access = access;
                    break;

                  case "Virtual service invoicing":
                    element.virtual_invoice_access = access;
                    break;
                }
              });
            }
          });
          let checkForAccessLength = this.businessListData.length;
          this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0, // Add the isSelected property
            }))
            .filter(
              (element: any) =>
                (element.is_owner == 1 &&
                  element.entitySubscriptionInfo &&
                  element.entitySubscriptionInfo !== "null") ||
                (element.is_owner != 1 &&
                  element.entitySubscriptionInfo &&
                  element.entitySubscriptionInfo !== "null" &&
                  element.employeeSubscriptionInfo &&
                  element.employeeSubscriptionInfo !== "null" &&
                  element.employee_status == 1 &&
                  element.member_access == 1)
            );
          if (checkForAccessLength - this.businessListData.length > 0) {
            this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true;
          }
          if (this.businessListData.length > 0) {
            this.businessListData[0].isSelected = 1;
            this.selectedBusiness = this.businessListData[0];
            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
              this.selectedBusiness.entity_public_hash_id
            );
            localStorage.setItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
              this.selectedBusiness.employee_hash_id
            );
            sessionStorage.setItem(
              "shop_service_status",
              this.selectedBusiness.shop_service_status
            );
            sessionStorage.setItem(
              "home_service_status",
              this.selectedBusiness.home_service_status
            );
            sessionStorage.setItem(
              "virtual_service_status",
              this.selectedBusiness.virtual_service_status
            );

            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.shop_invoice_access
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.home_invoice_access
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.virtual_invoice_access
            );

            this.isEntityIndividual =
              this.selectedBusiness.revenue_model == 2 ? "1" : "0";

            let isEntityForeign =
              this.selectedBusiness.currency == "INR" ? "0" : "1";

            localStorage.setItem(
              SM_CONSTANTS.IS_ENTITY_FOREIGN,
              isEntityForeign
            );

            sessionStorage.setItem(
              "isEntityIndividual",
              this.selectedBusiness.revenue_model == 2 ? "1" : "0"
            );
            let countryList: any[] = COUNTRY_CODES;

            let selectedCurrency = {
              currency: this.selectedBusiness.currency,
              currencySymbol: this.selectedBusiness.currency_symbol,
              countryCode: this.selectedBusiness.entity_country_code,
              code: countryList.find(
                (country) =>
                  country.dial_code ===
                    this.selectedBusiness.entity_country_code &&
                  country.currency === this.selectedBusiness.currency
              )?.code,
            };
            sessionStorage.setItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
              JSON.stringify(selectedCurrency)
            );
          }
          console.log("bl", this.selectedBusiness);
          if(this.selectedBusiness){
            this.authService.setUserRole(
              this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
            );

          }
        }

        // this.loaderservice.showLoader = false
        // this.loader = false
        if (this.businessListData.length > 0) {
          this.apiservice.getEnrolledMembersListByType(
            this.selectedBusiness.hash_id,
            this.selectedValue,
            this.pageNo
          );
        } else {
          this.loaderservice.showLoader = false;
          this.loader = false;
        }
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_MEMBERS_SEARCH_BY_TYPE
      ) {
        this.membersData = [];
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          resdata.result.forEach((element: any) => {
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "last_payment_date" &&
                  key != "membership_start_date" &&
                  key != "email" &&
                  key != "dob" &&
                  key != "products" &&
                  key != "custom_items" &&
                  key != "services" &&
                  key != "coupon_info"
                ) {
                  (element as any)[key] = "N/A";
                }
              }

              if (element.service_mode == 0) {
                element.s_mode = "Home service";
              } else if (element.service_mode == 1) {
                element.s_mode = "In-premise service";
              } else if (element.service_mode == 2) {
                element.s_mode = "Virtual service";
              }

              if (!element.last_payment_date) {
                element.last_payment_dt = "---";
              } else if (element.last_payment_date) {
                element.last_payment_dt = new Date(
                  element.last_payment_date
                ).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                });
              }

              element.member_phone = element.country_code + " " + element.phone;
            });
            this.membersData.push(element);
          });
        }
        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_MEMBER_DATA_BY_KEYWORD
      ) {
        this.membersData = [];
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          resdata.result.forEach((element: any) => {
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "last_payment_date" &&
                  key != "membership_start_date" &&
                  key != "email" &&
                  key != "dob" &&
                  key != "products" &&
                  key != "custom_items" &&
                  key != "services" &&
                  key != "coupon_info"
                ) {
                  (element as any)[key] = "N/A";
                }
              }

              if (element.service_mode == 0) {
                element.s_mode = "Home service";
              } else if (element.service_mode == 1) {
                element.s_mode = "In-premise service";
              } else if (element.service_mode == 2) {
                element.s_mode = "Virtual service";
              }

              element.member_phone = element.country_code + " " + element.phone;
            });
            this.membersData.push(element);
          });
        }
        // this.apiservice.getBillDiscountData(
        //   localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
        // );
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_MEMBERS
      ) {
        if (resdata.result) {
          if (resdata.result.errorcode == 0) {
            if (
              resdata.result.whatsapp_share == 0 &&
              (resdata.result.email_share == 1 ||
                resdata.result.email_share == 2 ||
                resdata.result.email_share == 3)
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation via WhatsApp as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: {
                        entityHash: this.selectedBusiness.hash_id,
                      },
                    }
                  );
                }
              });
            } else if (
              resdata.result.whatsapp_share == 1 &&
              resdata.result.email_share == 0
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation Email as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: {
                        entityHash: this.selectedBusiness.hash_id,
                      },
                    }
                  );
                }
              });
            } else if (
              resdata.result.whatsapp_share == 0 &&
              resdata.result.email_share == 0
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation via Email and WhatsApp as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: {
                        entityHash: this.selectedBusiness.hash_id,
                      },
                    }
                  );
                }
              });
            }
            this.apiservice.getEnrolledMembersListByType(
              this.selectedBusiness.hash_id,
              this.selectedValue,
              this.pageNo
            );
          }
          // this.loaderservice.showLoader = false
          // this.activemodal.close({msg: 'success'})
        }
      }

      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENROLLED_MEMBER_MEMBERSHIP_STATUS
      ) {
        if (resdata.result) {
          this.apiservice.getEnrolledMembersListByType(
            this.selectedBusiness.hash_id,
            this.selectedValue,
            this.pageNo
          );
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (resdata.result) {
          this.apiservice.getEnrolledMembersListByType(
            this.selectedBusiness.hash_id,
            this.selectedValue,
            this.pageNo
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resdata.result) {
          this.apiservice.getEnrolledMembersListByType(
            this.selectedBusiness.hash_id,
            this.selectedValue,
            this.pageNo
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_MEMBER_DATA
      ) {
        if (resdata.result) {
          this.apiservice.getEnrolledMembersListByType(
            this.selectedBusiness.hash_id,
            this.selectedValue,
            this.pageNo
          );
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resdata.result) {
          this.apiservice.getEnrolledMembersListByType(
            this.selectedBusiness.hash_id,
            this.selectedValue,
            this.pageNo
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resdata.result) {
          this.apiservice.getEnrolledMembersListByType(
            this.selectedBusiness.hash_id,
            this.selectedValue,
            this.pageNo
          );
        }
      }
    });
  }

  ngOnInit(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      queryParamsHandling: "", // Clears all other params
      replaceUrl: true,
    });
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH);
    sessionStorage.removeItem("mefrp");
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }
  createNewBusiness() {
    this.router.navigate(["purchased-plan"]);
  }

  selectedValue: string = "1";
  pageNo: number = 1;
  changeChip(value: string) {
    this.selectedValue = value;
    this.loader = true;
    this.loaderservice.showLoader = true;
    // if(value == '0'){
    //   this.apiservice.getCustomersByEntityId(this.selectedBusiness.hash_id,  this.page.toString())
    // }
    // else if(value == '1'){
    //   this.apiservice.getCustomersWithDuesByEntityId(this.selectedBusiness.hash_id,  this.page.toString())
    // }
    // else if(value == '2'){
    //   this.apiservice.getLongAbsentCustomersByEntityId(this.selectedBusiness.hash_id,  this.page.toString())
    // }
    this.apiservice.getEnrolledMembersListByType(
      this.selectedBusiness.hash_id,
      this.selectedValue,
      this.pageNo
    );
  }

  selectBusiness(index: any) {
    this.businessListData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessListData[index].isSelected = 1;
    this.selectedBusiness = this.businessListData[index];
    this.isEntityIndividual =
      this.selectedBusiness.revenue_model == 2 ? "1" : "0";

    let isEntityForeign = this.selectedBusiness.currency == "INR" ? "0" : "1";

    localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, isEntityForeign);
    sessionStorage.setItem(
      "isEntityIndividual",
      this.selectedBusiness.revenue_model == 2 ? "1" : "0"
    );
    let countryList: any[] = COUNTRY_CODES;

    let selectedCurrency = {
      currency: this.selectedBusiness.currency,
      currencySymbol: this.selectedBusiness.currency_symbol,
      countryCode: this.selectedBusiness.entity_country_code,
      code: countryList.find(
        (country) =>
          country.dial_code === this.selectedBusiness.entity_country_code &&
          country.currency === this.selectedBusiness.currency
      )?.code,
    };
    sessionStorage.setItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
      JSON.stringify(selectedCurrency)
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      this.selectedBusiness.entity_public_hash_id
    );
    sessionStorage.setItem(
      "shop_service_status",
      this.selectedBusiness.shop_service_status
    );
    sessionStorage.setItem(
      "home_service_status",
      this.selectedBusiness.home_service_status
    );
    sessionStorage.setItem(
      "virtual_service_status",
      this.selectedBusiness.virtual_service_status
    );

    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.shop_invoice_access
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.home_invoice_access
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.virtual_invoice_access
    );

    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      this.selectedBusiness.employee_hash_id
    );

    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
    );

    this.hidediv = true;
    this.loaderservice.showLoader = true;
    this.changeChip("1");
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this.apiservice.getMemberDataByKeyword(
        this.selectedBusiness.hash_id,
        this.page.toString(),
        this.searchString.value,
        this.selectedValue
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        this.apiservice.getEnrolledMembersListByType(
          this.selectedBusiness.hash_id,
          this.selectedValue,
          this.pageNo
        );
      }
    }
  }

  reset() {
    this.firstTimeBelow3 = false;
    this.searchString.reset();
    this.page = 1;
    this.apiservice.getEnrolledMembersListByType(
      this.selectedBusiness.hash_id,
      this.selectedValue,
      this.pageNo
    );
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/jCpDxXA4TZA",
        title: "How to manage members?",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  viewdetailsopen(item: any) {
    this._modelRef.open(CustomersViewDetailsComponent, {
      width: "600px",
      data: {
        customerData: item,
        title: "view details",
        ref: this._modelRef,
      },
    });
  }
  discountInfo: any = null;
  createInvoice(customer: any) {
    let data = {
      entityHash: this.selectedBusiness.hash_id,
      eph: this.selectedBusiness.entity_public_hash_id,
      customer: customer,
      discountInfo: this.discountInfo,
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this._modelRef.open(CreateInvoiceForCustomersComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  addcustomer() {
    let dialogref = this.dialog.open(AddCustomerComponent, {
      width: "500px",
      disableClose: true,
      data: {
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
        link: "",
        title: "Add customer",
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res[0].errorcode == 1) {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another customer with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.loaderservice.showLoader = true;
          this.apiservice.getCustomersByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString()
          );
        }
      }
    });
  }

  openAllBookings(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }
  openAllPayments(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }
  openDueBookings(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["due-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }

  deleteCustomer(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this customer?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.selectedBusiness.hash_id,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityCustomer(obj);
      }
    });
  }

  selectcountry() {
    let dialogref = this.dialog.open(SelectBusinessCountryComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Select business country",
        ref: this.dialog,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.router.navigate(["purchased-plan"]);
      }
    });
  }

  formatDateToReadable(date: Date): string {
    // Use Angular's formatDate utility for localization and formatting
    return formatDate(date, "MMM d, y", "en-US");
  }

  goviewdetails(rowvalue: any) {
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
    );
    sessionStorage.setItem("mefrp", rowvalue.email);
    this.router.navigate(["member-details"], {
      relativeTo: this.route,
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
        memberHash: rowvalue.hash_id,
      },
    });
  }

  openViewAttendance(rowvalue: any) {
    this.router.navigate(["view-attendance"], {
      relativeTo: this.route,
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        memberHash: rowvalue.hash_id,
        mn: rowvalue.name,
      },
    });
  }
  createInvoiceForEnrolled(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    let data = {
      entityHash: this.selectedBusiness.hash_id,
      eph: this.selectedBusiness.entity_public_hash_id,
      // serviceType: this.interestType,
      enrolledData: {
        customer_name: item.name,
        customer_country_code: item.country_code,
        customer_phone: item.phone,
        customer_email: item.email,
      },
      memberData: item,
      discountInfo: this.discountInfo,
    };

    this.dialog.open(CreateInvoiceForFitnessComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this.dialog,
        data: data,
      },
    });
  }

  openAllInvoices(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    console.log(item);

    this.router.navigate(["all-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        memberHash: item.hash_id,
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
      },
    });
  }
  openDueInvoices(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    this.router.navigate(["due-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        memberHash: item.hash_id,
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
      },
    });
  }
  openPaymentIntimation(item: any) {
    this._modelRef.open(PaymentIntimationComponent, {
      width: "700px",
      data: {
        title: "Payment Intimation",
        ref: this._modelRef,
        data: item,
        type: 2,
        entity_hash: this.selectedBusiness.hash_id
      },
    });
  }
  openmarkabsent(rowvalue: any) {
    this.dialog.open(MarkAbsentComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Mark absent",
        entityHash: this.selectedBusiness.hash_id,
        memberHash: rowvalue.hash_id,
      },
    });
  }

  addmember() {
    // this.dialog.open(AddMemberComponent,{
    //   width:'500px',
    //   disableClose:true,
    //   data:{
    //     link:"",
    //     title: 'Add member'
    //   }})

    let data = {
      entityHash: this.selectedBusiness.hash_id,
      // serviceType: this.interestType,
    };

    let dialogref = this.dialog.open(PhoneCheckForMemberComponent, {
      width: "500px",
      data: {
        title: "Add member",
        ref: this.dialog,
        data: data,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        // this.loader = true
        // this.loaderservice.showLoader = true
        // this._apiService.getEnrolledMembersListByType(this.selectedBusiness.hash_id,this.selectedValue,this.pageNo)
      }
    });
  }

  getInvoiceAccess(serviceType: any): boolean {
    if (this.selectedBusiness.is_owner) return true;
    else {
      const ssa = this.selectedBusiness.shop_invoice_access;
      const hsa = this.selectedBusiness.home_invoice_access;
      const vsa = this.selectedBusiness.virtual_invoice_access;

      const bsss = this.selectedBusiness.shop_service_status;
      const bhss = this.selectedBusiness.home_service_status;
      const bvss = this.selectedBusiness.virtual_service_status;

      if (
        (ssa == "1" && bsss != '2' && serviceType == "1") ||
        (hsa == "1" && bhss != '2' && serviceType == "0") ||
        (vsa == "1" && bvss != '2' && serviceType == "2")
      ) {
        return true;
      }
    }

    return false;
  }
}
